// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanel from 'viewmodel/AwPanelViewModel';
import AwList from 'viewmodel/AwListViewModel';
import AwImageCell from 'viewmodel/AwImageCellViewModel';
    

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/DesTeamService', () => import('js/DesTeamService'));
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/desCatalogEventBus', () => import('js/desCatalogEventBus'));
registerDynImportEntry('js/DesCommonService', () => import('js/DesCommonService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "imports": [],
    "props": {
        "collaborationspaceid": {
            "type": "string"
        },
        "acc-id": {
            "type": "string"
        },
        "accsessionid": {
            "type": "string"
        },
        "autoSelectFirst": {
            "type": "boolean"
        }
    },
    "lifecycleHooks": {
        "onMount": "subscribeDeleteTeamEvent",
        "onUnmount": "unsubscribeDeleteTeamEvent"
    },
    "dataProviders": {
        "teamListViewDataProvider": {
            "action": "fetchTeamList",
            "response": "{{data.teamListViewResponse}}",
            "selectionModelMode": "single",
            "commandsAnchor": "des_TeamOptionCommandAnchor",
            "position": "BOTTOM_RIGHT"
        }
    },
    "data": {
        "limit": 50,
        "teamList": {
            "displayName": "Team List",
            "type": "STRING",
            "isRequired": "true",
            "isEditable": "true",
            "dbValue": "",
            "dispValue": ""
        },
        "teamToRemove": {
            "type": "STRING"
        },
        "nameOfTeamToRemove": {
            "type": "STRING"
        }
    },
    "actions": {
        "reveal": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "refreshTeamList"
                }
            ]
        },
        "subscribeDeleteTeamEvent": {
            "actionType": "JSFunction",
            "method": "toggleDeleteTeamEvent",
            "inputData": {
                "addListner": false
            },
            "deps": "js/DesTeamService"
        },
        "unsubscribeDeleteTeamEvent": {
            "actionType": "JSFunction",
            "method": "toggleDeleteTeamEvent",
            "inputData": {
                "removeListner": true
            },
            "deps": "js/DesTeamService"
        },
        "fetchTeamList": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "collaborationspaceid": "{{props.collaborationspaceid}}"
                        },
                        "query": "query ListAllTeams($listTeamsInput: ListTeamsInput) {listAllTeams(listTeamsInput: $listTeamsInput)}",
                        "variables": {
                            "listTeamsInput": {
                                "searchOptions": {
                                    "skip": 0,
                                    "limit": "{{data.limit}}",
                                    "outputProperties": [
                                        "*"
                                    ]
                                }
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}"
            },
            "outputData": {
                "teamListViewTotalResults": "data.data.listAllTeams.totalCount",
                "teamListViewResponse": "data.data.listAllTeams.teamObjs"
            },
            "events": {
                "failure": [
                    {
                        "name": "listAllTeams.failure",
                        "eventData": {
                            "eventName": "listAllTeamsFailure",
                            "eventData": "{{teamListViewResponse}}"
                        }
                    }
                ],
                "success": [
                    {
                        "name": "listAllTeams.success",
                        "eventData": {
                            "eventName": "listAllTeamsSuccess",
                            "eventData": "{{props.collaborationspaceid}}"
                        }
                    }
                ]
            },
            "actionMessages": {
                "failure": [
                    {
                        "message": "queryFailedMessage"
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "refreshTeamList": {
            "actionType": "dataProvider",
            "method": "teamListViewDataProvider"
        },
        "removeTeam": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "collaborationspaceid": "{{props.collaborationspaceid}}"
                        },
                        "query": "mutation DeleteTeam($deleteTeamInput: DeleteTeamInput) {deleteTeam( deleteTeamInput: $deleteTeamInput)}",
                        "variables": {
                            "deleteTeamInput": {
                                "teamId": "{{parameters.eventData.teamId}}"
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}"
            },
            "outputData": {
                "removedTeam": "data.data.deleteTeam"
            },
            "events": {
                "success": [
                    {
                        "name": "desDeleteTeamSuccess",
                        "eventData": {
                            "eventName": "desDeleteTeamSuccess",
                            "eventData": "{{removedTeam}}"
                        }
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "publishToACCEventBus": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "{{parameters.eventName}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desCatalogEventBus"
        },
        "updateLocalVariable": {
            "actionType": "JSFunction",
            "method": "updateVmoVariables",
            "inputData": {
                "data": "{{data}}",
                "keysToUpdate": {
                    "selectedTeam": "{{parameters.eventData}}"
                }
            },
            "deps": "js/DesCommonService"
        },
        "batchActionOnTeamSelection": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "publishToACCEventBus",
                    "inputArgs": {
                        "eventName": "{{parameters.eventName}}",
                        "eventData": "{{parameters.eventData}}"
                    }
                },
                {
                    "action": "updateLocalVariable",
                    "inputArgs": {
                        "eventData": "{{parameters.eventData}}"
                    }
                }
            ]
        },
        "removeSearchedUsersConfirmation": {
            "actionType": "Event",
            "method": "Event",
            "actionMessages": {
                "success": [
                    {
                        "message": "doYouWantToRemoveSelectedUsers"
                    }
                ]
            }
        },
        "doYouWantToRemoveSelectedUsers": {
            "messageType": "WARNING",
            "messageText": "{{i18n.removeUserConfirmationMessage}}",
            "messageTextParams": [],
            "navigationOptions": [
                {
                    "option": "Discard",
                    "text": "{{i18n.cancel}}",
                    "action": "popupPanelClose"
                },
                {
                    "option": "Continue",
                    "text": "{{i18n.remove}}",
                    "action": "removeTeam",
                    "inputArgs": {
                        "eventName": "{{eventData.eventName}}",
                        "eventData": "{{eventData.eventData}}"
                    }
                }
            ]
        }
    },
    "onEvent": [
        {
            "eventId": "desCreateTeamSuccess",
            "action": "reveal",
            "cacheEventData": true
        },
        {
            "eventId": "desUpdateTeamSuccess",
            "action": "reveal",
            "cacheEventData": true
        },
        {
            "eventId": "desDeleteTeamSuccess",
            "action": "reveal",
            "cacheEventData": true
        },
        {
            "eventId": "teamListViewDataProvider.selectionChangeEvent",
            "cacheEventData": true,
            "action": "batchActionOnTeamSelection",
            "inputArgs": {
                "eventName": "desTeamListSelectionChange",
                "eventData": "{{eventData.selectedObjects}}"
            }
        },
        {
            "eventId": "removeTeamAction_EventName",
            "action": "removeSearchedUsersConfirmation",
            "inputArgs": {
                "eventName": "{{eventData.eventName}}",
                "eventData": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "deleteSelectedTeam",
            "action": "removeTeam",
            "inputArgs": {
                "eventName": "{{eventData.eventName}}",
                "eventData": "{{eventData.eventData}}"
            }
        }
    ],
    "messages": {
        "queryFailedMessage": {
            "messageType": "ERROR"
        },
        "displayDesDeleteTeamSuccessMsg": {
            "messageType": "INFO",
            "messageText": "{{i18n.deleteTeamSuccessMsg}}"
        },
        "displayDesDeleteUserFailureMsg": {
            "messageType": "ERROR",
            "messageText": "{{i18n.deleteTeamFailedMsg}}"
        },
        "deleteTeamConfirmPopup": {
            "messageType": "WARNING",
            "messageText": "\"{0}\" will be deleted.",
            "navigationOptions": [
                {
                    "option": "cancel",
                    "text": "Cancel",
                    "action": ""
                },
                {
                    "option": "delete",
                    "text": "Delete",
                    "action": "removeTeam"
                }
            ],
            "messageTextParams": [
                "{{data.nameOfTeamToRemove.dbValue}}"
            ]
        }
    },
    "conditions": {},
    "i18n": {
        "commandPanelDemo": [
            "DesTeamMessages"
        ],
        "teamName": [
            "DesTeamMessages"
        ],
        "teamDescription": [
            "DesTeamMessages"
        ],
        "createTeamSuccessMsg": [
            "DesTeamMessages"
        ],
        "message": [
            "DesTeamMessages"
        ],
        "createButton": [
            "DesTeamMessages"
        ],
        "commandPanelCreateTeam": [
            "DesTeamMessages"
        ],
        "submitButtonTitle": [
            "TCUICommandPanelsMessages"
        ],
        "removeUserConfirmationMessage": [
            "DesTeamMessages"
        ],
        "remove": [
            "DesTeamMessages"
        ],
        "cancel": [
            "DesTeamMessages"
        ],
        "deleteTeamSuccessMsg": [
            "DesTeamMessages"
        ],
        "deleteTeamFailedMsg": [
            "DesTeamMessages"
        ]
    },
    "_viewModelId": "DesTeamList",
    "_uniqueViewModelId": "DesTeamList",
    "ctx": {}
};

    /*
    <aw-panel class="des-image-styling-teamList">
    <aw-list dataprovider="data.dataProviders.teamListViewDataProvider">
        <aw-image-cell vmo="item"> </aw-image-cell>
    </aw-list>
</aw-panel>
    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwPanel  revealAction={actions.reveal}  className="des-image-styling-teamList">
        <AwList dataprovider={dataProviders.teamListViewDataProvider} showDropArea={null} dndHandler={props.viewModel.dndHandler}>{({item, index})=>{ return <>            <AwImageCell vmo={AwParseService.instance( "item" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports, item, index } )}>
            </AwImageCell></> } }
        </AwList>
    </AwPanel>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;